module.exports = __webpack_public_path__ + "img/small-logo.7e4a943.svg";